import { Component, OnInit, EventEmitter, Output,ViewChild,ElementRef,ChangeDetectorRef, Inject } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { SharedserviceService,CommonService } from 'src/app/services';
import { DatePipe, getLocaleTimeFormat } from '@angular/common';
import { ToastrManager } from 'ng6-toastr-notifications';
import {Sort} from '@angular/material/sort';
import jspdf from 'jspdf';
import domtoimage from 'dom-to-image';
import { DOCUMENT } from '@angular/common';
import { DateAdapter } from '@angular/material';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { environment } from 'src/environments/environment';
import { JsonpInterceptor } from '@angular/common/http';
// import { Product } from './product';
declare var $: any;

@Component({
  selector: 'app-success',
  templateUrl: './success.component.html',
  styleUrls: ['./success.component.scss'],
  providers: [DatePipe, NgxUiLoaderService]
})
export class SuccessComponent implements OnInit {
  add_balance_bool:boolean=JSON.parse(sessionStorage.getItem("add_balance_bool"));  imagepathstatic = environment.imageurl;  pymtData:any;
  checkTraveler : any=[];  summaryDtl: boolean = false;  bookingid:any;  reference_id:any;  transaction_id:any;  BookingDataStore:any;
  bookingdata:any;  directBooking:any;  userdata:any;  EditValuSummery: boolean = false;  userList: any = {};  imgUrl:any;  imgPath:any;
  bgBannerPath:any;  imgProfile:any;  profileImg1:any;  loadData:any;data:any;keys:any;public page: number = 1;start = 0;msg:any;
  ccData:any;  TotalCount:any;  totalpage:any;  return_d_date:any;  rreturn_d_date:any;  i=1;  bookData:any;  flightData:any;  returnFlight:any;
  flt_bokg_dtl:any=[];  nodatafound:boolean=false;  cancelticket:any;  delBox:boolean=false;  sortedBook: any[];  sectordata:any;
  userlist:any;  editFormFlag:boolean=false;uploadedImagesData: any;  selectedFile: File=null;status:any;EditFormData:any;FormId:any;
  bodydata:any={};PackageStatus:any;  myDate = new Date();  todate:any="";  formdate:any="";  sector:any="";  type:any="";  filterstatus:any="";
  headBner: boolean = false;  element:any;  fd_basefare: any;  fd_feetaxes: any;  fd_discount: any;  fd_amount: any;  contactDtl: boolean =false;
  ownerDataValue: any; partnerSearch:boolean=false; Booking_token:any; Flight_booking_requestdata:any; Show_success:any=0;
  Regularsearch:boolean=false; inv_from:any=JSON.parse(sessionStorage.getItem("inventory_from"));
  constructor(
    public httpClient: SharedserviceService,
    private router:Router,  private ngxLoader: NgxUiLoaderService,  private dateAdapter: DateAdapter<Date>,  private datePipe : DatePipe,
    private formBuilder: FormBuilder,  public sharedService: SharedserviceService,  public commonService:CommonService,
    @Inject(DOCUMENT) private document: Document,  private toastr: ToastrManager
  ) 
  { 
    if(this.add_balance_bool == true){
      this.Regularsearch=JSON.parse(sessionStorage.getItem("Regular Search"));
      this.partnerSearch = JSON.parse(sessionStorage.getItem("partnerSearch"))
      this.Booking_token = JSON.parse(sessionStorage.getItem("Booking_token"))
      this.Flight_booking_requestdata = JSON.parse(sessionStorage.getItem("flight_booking_request"))
    }else{
      this.Show_success=1;
      this.BookingDataStore=JSON.parse(sessionStorage.getItem("front_booking_data"));  
      this.directBooking=JSON.parse(sessionStorage.getItem("booking_data_agency"));
    }
    this.dateAdapter.setLocale('en-GB');  this.userdata=JSON.parse(localStorage.getItem("userAgency_diamond"));
    this.imgProfile=JSON.parse(localStorage.getItem("imgpathAgency"));  this.imgProfile=JSON.parse(sessionStorage.getItem("imagepath"));
    this.ownerDataValue=JSON.parse(sessionStorage.getItem("ownerData"));
  }
  ngOnInit() {
    if(this.userdata){  this.profileImg1 = this.imgProfile +'/'+this.userdata.image;}
    else{  this.profileImg1 = this.imgProfile +'/'+this.ownerDataValue.image;  }
    
    if(this.add_balance_bool == true){
      // this.getWalletBalance();
      if(this.partnerSearch == true){
        if(this.Regularsearch == true){
          this.Commonbook(`v1/fit/book/${this.inv_from}`,this.Flight_booking_requestdata)
        }else{
          this.Commonbook(`v1/common_new/book/${this.inv_from}`,this.Flight_booking_requestdata)
        }
      }else{
        this.NormalBook('v1/flight_booking',this.Flight_booking_requestdata)
      }
      
    }
    else{
      if(this.BookingDataStore){
        this.bookingid=this.BookingDataStore.booking_id;  this.reference_id=this.BookingDataStore.reference_id;  
        this.transaction_id=this.BookingDataStore.transaction_id;  this.successCallback(this.BookingDataStore);
      }
      else{
        this.bookingid=this.directBooking.booking_id;  this.reference_id=this.directBooking.reference_id;
        this.transaction_id=this.directBooking.transaction_id;  this.successCallback(this.directBooking);
      }
      setInterval(function(){  $('#genrepo1').modal('show');  }, 0);
      this.viewDetail(this.bookingid,this.reference_id);
    }
  }

  EditValu() {  this.EditValuSummery = !this.EditValuSummery;  }

  onAddUser() {
    this.userList = {   basefare: this.fd_basefare,    feetexs: this.fd_feetaxes,    dis: this.fd_discount,    amt: this.fd_amount };
    $('#EditValuSummery').modal('hide');  $('#baseFareOld').hide();  $('#baseFareOld1').hide();  $('#baseFareOld2').hide();  $('#baseFareOld3').hide();
    this.EditValuSummery = false;
  }

  closeEdit() {
    this.EditValuSummery = false;
  }

  successCallback = function (paymentData) {
    var self = this;
    self.transcationID = paymentData.TXNID;
       var sendReqData = {    "flight_booking_id":this.bookingid,   "reference_id":this.reference_id }
      this.sharedService.post('v1/flight_booking/get_booking_payment_status',sendReqData).subscribe((res: any) => {
        if (res.replyCode == "success") {   this.pymtData = res.data;  this.messageData = res; }
          else {    self.sharedService.showError(res.replyMsg,'Error');   self.location.back();    self.toastr.errorToastr(res.replyMsg);  }
       });
  };

  summaryShow(event) {
    if (event.checked == true) {  this.summaryDtl = true;} 
    else {    this.summaryDtl = false;  }
  }

  contactShow(event) {
    if (event.checked == true) {  this.contactDtl = true;} 
    else {    this.contactDtl = false;  }
  }

 

  durationdiff(dep_time,arr_time,dep_date,type){
    //
//  console.log("values are :",dep_time,arr_time,dep_date);
    var dep_hr=parseInt(dep_time.split(':')[0]);
    var arr_hr=parseInt(arr_time.split(':')[0]);
    //
// console.log("hr :: ",dep_hr,arr_hr);
    if(arr_hr < dep_hr){
      var nwdate;
      if(!dep_date){
        nwdate =  new Date();
      }else{
       nwdate =  new Date(dep_date);
      }
      
      var newdate= nwdate.setDate(nwdate.getDate()+1);
      if(type == 'oneway'){
        this.return_d_date=this.datePipe.transform(newdate, 'yyyy-MM-dd');
      }else{
        this.rreturn_d_date=this.datePipe.transform(newdate, 'yyyy-MM-dd');
      }
     
    } else{
      this.return_d_date=dep_date;
      this.rreturn_d_date=dep_date;
    } 
    //
//console.log("hr :: ",this.return_d_date); 
    var start_date=dep_date+" "+dep_time;
    var end_date=this.return_d_date+" "+arr_time;  
    //
//console.log("start date : ",start_date,"end date :: ",end_date);
    return this.getDataDiff(new Date(start_date.toString()), new Date(end_date.toString()));
    
  }

  // generatePDF1() {
  //   var data = document.getElementById('contentToConvert1');
  //   this.ngxLoader.start();
  //     const options = { background: 'white', height: 1000, width: 1200 };
  //     var imgWidth = 208;
  //     var imgHeight = 170 * imgWidth / imgWidth;
  //     domtoimage.toPng(data, options).then((dataUrl) => {
  //         const doc = new jspdf('p', 'mm', 'a4');
  //         doc.addImage(dataUrl, 'PNG', 0, 0, imgWidth, imgHeight);
  //         this.ngxLoader.stop();
  //         doc.save('Download.pdf');
  //     });
  // }

  printpreview(){
    var printW = window.open("");
    var html = document.getElementById('contentToConvert1').innerHTML;

    printW.document.write('<html><head><title>Booking Details</title>');
     printW.document.write(`<link rel="stylesheet" href="https://stackpath.bootstrapcdn.com/bootstrap/4.5.2/css/bootstrap.min.css" type="text/css" />`);
     printW.document.write(`<style>
     .col-3 {-webkit-box-flex: 0;flex: 0 0 25%;max-width: 25%;}
     .col-6 {-webkit-box-flex: 0;flex: 0 0 50%;max-width: 50%;}
     table td{border-bottom:1px solid #ddd;padding:5px;border-collapse: collapse;} table th {border-collapse: collapse;padding:5px;font-weight: 600;color: #000;} table{ width: 100%; border-spacing:1px;border-collapse: separate;}.row{display: flex;flex-wrap: wrap;width:100%;}.col-md-6 {-webkit-box-flex: 0;flex: 0 0 50%;max-width: 50%;}.img-box {width: 50px;height: 50px;border: 1px solid #ddd;object-fit:cover;} 
     .border {border: 1px solid #dee2e6!important;}
     table{margin-bottom:5px !important;}
     .ph-text{height:250px !important;font-size:10px !important;line-height:15px !important;}
     .row {display: -webkit-box;display: flex;flex-wrap: wrap;}
     .text-left {text-align: left!important;}
     .img-profile {height: auto;-o-object-fit: contain;object-fit: contain;max-height: 60px;float:left;}
      .text-center {text-align: center!important;}
      .col-6 {-webkit-box-flex: 0;flex: 0 0 50%;max-width: 50%;}
      .head-clr {color: #ff6a00;}.fw-500 {font-weight: 500;}
      .m-0 {margin: 0!important;}.w-100 {width: 100%!important;}.text-center {text-align: center!important;}
      .bg-white {background-color: #fff!important;}
      table {border-collapse: collapse;}
      .table {width: 100%;color: #212529;}
      .col-lg-4 {-webkit-box-flex: 0;flex: 0 0 33.333333%;max-width: 33.333333%;}
      .wp-100{width:100%;} .wp-30{width:30% !important;}
      .h1, .h2, .h3, .h4, .h5, .h6, h1, h2, h3, h4, h5, h6 {
        margin-bottom:.5rem !important;font-weight: 500;line-height: 1.2;}
      .mytbl td {padding: 0.5rem;margin-bottom: 0rem !important;}
      .mytbl td {padding: 0.5rem !important;vertical-align: middle;padding-left: 0.75rem !important;}
      .table td, .table th {padding: .75rem;vertical-align: top;border-top: 1px solid #dee2e6;}
      .border-bottom {border-bottom: 1px solid #dee2e6!important;}
      .img-box-fix {width: 50px;height: 30px;-o-object-fit: contain;object-fit: contain;}
      img {vertical-align: middle;border-style: none;}
      .textclr {color: #828282;}
      .ft-12 {font-size: 12px !important;}
      .align-self-center {align-self: center!important;}
      .table-responsive {display: block;width: 100%;overflow-x: auto;-webkit-overflow-scrolling: touch;}
      .d-none {display: none!important;}.text-dark {color: #343a40!important;}.h6, h6 {font-size: 1rem;}
      .form-control:disabled, .form-control[readonly] {background-color: #e9ecef !important;opacity: 1;}
      .form-control {display: block;width: 100%;height: calc(1.5em + .75rem + 2px);padding: .375rem .75rem;font-size: 1rem;
        font-weight: 400;line-height: 1.5;color: #495057;background-color: #fff;background-clip: padding-box;border: 1px solid #ced4da;border-radius: .25rem;-webkit-transition: border-color .15s ease-in-out,box-shadow .15s ease-in-out;transition: border-color .15s ease-in-out,box-shadow .15s ease-in-out;}
      .prnt-h{line-height:32px !important;}
      .form-control-1{border:1px solid #ddd;border-radius:5px;background-color:#e9ecef;color:#303030;padding:8px;}
      .w-10pr{width:10%;}.w-14pr{width:14%;}.w-25pr{width:25%;}
      .pmt-10{margin-top:10px;}.p-Size{font-size:12px;}.pmb-1{margin-bottom:10px !important;}.pmb-2{margin-bottom:15px !important; }
      .mytbl tr td{padding:2px;}.pmt-1{margin-bottom:10px !important;}.pmt-2{margin-bottom:15px !important; }
      .pr-dnone{display:none !important;}
      </style>`);
    printW.document.write('</head><body >');
    printW.document.write(html);
    printW.document.write('</body></html>');



   // var html = document.getElementById('contentToConvert1').innerHTML;
    // printW.document.write(html);
    printW.document.close();
    printW.focus();
    printW.print();
    // if(this.commonService.osname != "Mac OS"){
  //   printW.close();
  // }else{
  //   console.log("not Windows os")
  // }

  }
  getDataDiff(s_date, e_date){
    var diff = e_date.getTime() - s_date.getTime();
    var days = Math.floor(diff / (60 * 60 * 24 * 1000));
    var hours = Math.floor(diff / (60 * 60 * 1000)) - (days * 24);
    var minutes = Math.floor(diff / (60 * 1000)) - ((days * 24 * 60) + (hours * 60));
    var seconds = Math.floor(diff / 1000) - ((days * 24 * 60 * 60) + (hours * 60 * 60) + (minutes * 60));
    return hours+" hrs "+": "+minutes+" min";
    // return { day: days, hour: hours, minute: minutes, second: seconds };
  }

//   viewDetail(bookingid,reference_id){
//     // 
//     this.userList = {}
//     this.fd_basefare = ''
//     this.fd_feetaxes = ''
//     this.fd_discount = '';
//     this.fd_amount = '';
//     var self = this;
// //console.log("element data :::: ",element)
//     var self = this;
//     var Objects; 
//     if(this.userdata){
//       Objects={
//         user_id:this.userdata.id,
//         flight_booking_id:bookingid,
//       }
//     }else{
//       Objects={
        
//         flight_booking_id:bookingid,
//         booking_reference_id:reference_id,
//       }
//     }
    
    
// //console.log("object::::",Objects);    
//     this.sharedService.post('v1/flight/flight_booking_details', Objects).subscribe((res) => {
//       if (res.replyCode == 'success') {
//         this.bgBannerPath =res.bannerimgBasePath;
//         setTimeout(() => {
//           this.imgPath = res.imgBasePath;
//           this.bookData = res.data;
//           this.bookData.ticket_id=this.bookingid;
          
//           console.log("BookDataCheck:::::::::::::::::::",this.bookData);
//           this.flightData = res.data;
//           self.returnFlight = res.data.flightData.return_flight ;
//           self.flt_bokg_dtl = res.data.flight_booking_details;
//           var selectedText = this.bookData.departure_date;
//           var selectedDate = new Date(selectedText);
//           var now = new Date();
//           var newdate= now.setDate(now.getDate()-1);
//           if (selectedDate < new Date(newdate)) {
            
// //console.log("Date must be in the future");
//             this.bookData.nooption=1;
//           }else{
//             this.bookData.nooption=0;
//           }

//         }, 100);
       
//       }       
//     });
//     $('#genrepo1').modal('show');
//   }

viewDetail(bookingid,reference_id){
    
  this.userList = {}
  this.fd_basefare = ''
  this.fd_feetaxes = ''
  this.fd_discount = '';
  this.fd_amount = '';
//console.log("element data :::: ",element)
  var self = this;
  var Objects; 
  if(this.userdata){
    Objects={
      user_id:this.userdata.id,
      booking_id:bookingid,
    }
  }else{
    Objects={
      
      booking_id:bookingid,
      booking_reference_id:reference_id,
    }
  }

  console.log("check List of bookDataaa",Objects);
  // this.sharedService.post('v1/view_booking', Objects).subscribe((res) => {
  this.sharedService.post('v1/view_booking', Objects).subscribe((res) => {
    if (res.replyCode == 'success') {
      var counter = 0;
      this.bgBannerPath = res.bannerimgBasePath;
      this.bookData=res;
      console.log("check List of bookData",this.bookData);
      this.flt_bokg_dtl = res.passenger;
      
      setTimeout(() => {
        this.imgPath = res.imgBasePath;
        this.bookData = res;     
        this.flt_bokg_dtl = res.passenger;
        var selectedText = this.bookData.departure_date;
        var selectedDate = new Date(selectedText);
        var now = new Date();
        var newdate = now.setDate(now.getDate() - 1);
        if (selectedDate < new Date(newdate)) {
          this.bookData.nooption = 1;
        } else {
          this.bookData.nooption = 0;
        }
      }, 100);

    }
  }, err => {
    this.toastr.errorToastr(err.error.replyMsg, 'Error');
  });
  $('#genrepo1').modal('show');
  $('#baseFareOld').show();
  $('#baseFareOld1').show();
  $('#baseFareOld2').show();
  $('#baseFareOld3').show();
}
   
     
  viewDtl(){
    $('#genrepo1').modal('show');
  }

  closeClick(){
    $('#genrepo1').modal('hide');
    sessionStorage.removeItem("booking_data_agency")
    sessionStorage.removeItem("front_booking_data")
    if(this.userdata){
      this.router.navigateByUrl('/offerin')
    }else{
      this.router.navigateByUrl('/home-sector')
    }
  }

  // gotoHome(){
  //   sessionStorage.removeItem("booking_data_agency")
  //   sessionStorage.removeItem("front_booking_data")
  //   this.router.navigateByUrl('/offerin');
  //   $('#genrepo1').modal('hide');
  // }

  // getWalletBalance(){
  //   var self=this;
  //   this.httpClient.get('v1/wallet/get_wallet_balance').subscribe((res: any) => {
  //     self.httpClient.loadingShow = false;
  //     if (res.replyCode == "success") {
  //       if(res.wallet_balance != 0 ){
  //         if(this.partnerSearch == true){
  //           if(this.Regularsearch == true){
  //             this.Commonbook(`v1/fit/book/${this.inv_from}`,this.Flight_booking_requestdata)
  //           }else{
  //             this.Commonbook(`v1/common/book/${this.inv_from}`,this.Flight_booking_requestdata)
  //           }
  //         }else{
  //           this.NormalBook('v1/flight_booking',this.Flight_booking_requestdata)
  //         }
  //       }
  //     }
  //     if(res.replyCode == 'success' || res.replyCode == 'error'){ this.ngxLoader.stop(); }
  //   }, error => {  this.toastr.errorToastr(error.error.replyMsg, "Error");``  });
  // }

  NormalBook(url,data){
    var self=this;
    this.httpClient.postRequest(url, data).subscribe((res: any) => {
      self.httpClient.loadingShow = false;
      if (res.replyCode == "success") {
        this.ngxLoader.stop(); this.Show_success=2; this.pymtData=res.data;
          setInterval(function(){  $('#genrepo1').modal('show');  }, 0);  this.viewDetail(res.data.flight_booking_id,res.data.reference_id);
          sessionStorage.removeItem("imagepath");  sessionStorage.removeItem("flights");  sessionStorage.removeItem("searchedflights_detail");
          sessionStorage.removeItem("form_data");  localStorage.removeItem("inventory_flight_id");  localStorage.removeItem("inventory_d_date");
          localStorage.removeItem("traveller_by_inventory");  localStorage.removeItem("inventory_data");
      }
      if(res.replyCode == 'success' || res.replyCode == 'error'){ this.ngxLoader.stop(); }
    }, error => {  this.toastr.errorToastr(error.error.replyMsg, "Error");``  });
  }

  Commonbook(url,data){
    var self = this; data.pg=true;
    this.httpClient.postRequest(url, data).subscribe((res: any) => {
      self.httpClient.loadingShow = false;
      if (res.replyCode == "success") { this.Show_success=2; this.pymtData=res.data;
        this.ngxLoader.stop(); setInterval(function(){  $('#genrepo1').modal('show');  }, 0);  this.viewDetail(res.data.flight_booking_id,res.data.reference_id);
        localStorage.removeItem("traveller_by_inventory");  sessionStorage.removeItem("search_form");
        sessionStorage.removeItem("imagepath"); sessionStorage.removeItem("flights"); sessionStorage.removeItem("searchedflights_detail");
        sessionStorage.removeItem("form_data"); localStorage.removeItem("inventory_flight_id"); localStorage.removeItem("inventory_d_date");
        localStorage.removeItem("inventory_data"); localStorage.removeItem("companyname");
      } else {
        this.ngxLoader.stop();
        sessionStorage.removeItem("search_form"); sessionStorage.removeItem("imagepath"); sessionStorage.removeItem("flights");
        sessionStorage.removeItem("searchedflights_detail"); sessionStorage.removeItem("form_data"); localStorage.removeItem("inventory_flight_id");
        localStorage.removeItem("inventory_d_date"); localStorage.removeItem("inventory_data"); localStorage.removeItem("companyname");
        self.router.navigateByUrl("/dashboard");
      }
    }, error => {
      this.ngxLoader.stop();
      sessionStorage.removeItem("search_form"); sessionStorage.removeItem("imagepath"); sessionStorage.removeItem("flights"); 
      sessionStorage.removeItem("searchedflights_detail"); sessionStorage.removeItem("form_data"); localStorage.removeItem("inventory_flight_id");
      localStorage.removeItem("inventory_d_date"); localStorage.removeItem("inventory_data");
      self.router.navigateByUrl("/home/unsuccess"); this.toastr.errorToastr(error.error.replyMsg, "Error");
    });
  }

}
